<!-- Zweck: Stellt die HTML-Struktur für shop dtp zusatzdaten editor component im Frontend bereit. -->
@if (!editMode && entry.dtpErstOderFolgeverschreibungErfassen == true) {
<div>
  <mat-form-field>
    <mat-label>Erst oder Folgeverschreibung</mat-label>
    <mat-select [(ngModel)]="entry.dtpErstOderFolgeverschreibung" (selectionChange)="_change()" [disabled]="disabled">
      @for (opt of modes; track opt.id) {
        <mat-option [value]="opt.id">{{ opt.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
}

@if (editMode) {
  @if (!(editAllOk|async)) {
    <div style="text-align: center; padding: 20px;">
      <h3>
        <svg-icon>success</svg-icon> Alle Fehler behoben!
      </h3>
    </div>
  }
  @else {
    <div style="text-align: center; padding: 20px;">
      <h3>
        <svg-icon>info</svg-icon> Bitte korrigieren Sie die Fehler
      </h3>
    </div>
  }
}

@if (!entry.dtpErstOderFolgeverschreibungErfassen || (entry.dtpErstOderFolgeverschreibungErfassen && entry.dtpErstOderFolgeverschreibung != null)) {
  @for (dtpZusatzdaten of entry.dtpZusatzdaten; track dtpZusatzdaten.id; let i = $index) {
    @if (entry.dtpErstOderFolgeverschreibungErfassen == true && (dtpZusatzdaten.zusatzdaten.Erforderlichkeit == entry.dtpErstOderFolgeverschreibung || dtpZusatzdaten.zusatzdaten.Erforderlichkeit == null || dtpZusatzdaten.zusatzdaten.Erforderlichkeit == 'Immer') || !entry.dtpErstOderFolgeverschreibungErfassen) {
      @if (!editMode || dtpZusatzdaten.defect) {
        <shop-dtp-zusatzdaten-field-editor [editMode]="editMode" [bestellungId]="bestellungId" [warenkorbId]="warenkorbId" [zusatzdaten]="dtpZusatzdaten" [disabled]="disabled" (fieldChanged)="_fieldChange()"></shop-dtp-zusatzdaten-field-editor>
      }
    }
  }
}
